import { type TypeFilterValueKey } from '../../../../../common/constants/filters/universal-type';
import { type typeLabels } from './messages';

export const getTypeOptionMessageKey: (
	type: keyof typeof typeLabels,
) => TypeFilterValueKey | 'all' | 'pageAndLiveDoc' = (type: keyof typeof typeLabels) => {
	let messageKey: keyof typeof typeLabels = type;
	if (type === 'page') {
		messageKey = 'pageAndLiveDoc';
	}

	return messageKey;
};
